import React, { useRef, useEffect } from "react";

const Samacsys = ({ result }) => {
  const mountNode = useRef(null);
  const modelName = result?.model_name?.raw;
  const datasheet = result?.data_sheet_link?.raw;

  // Notify the Drupal-side Samacsys launcher that results have committed to the DOM.
  useEffect(() => {
    const node = mountNode.current;
    window?.omronSamacsysAgreement?.onResultsCommitted?.(node);
    return () => {
      window?.omronSamacsysAgreement?.onResultsDestroyed?.(node);
    };
  }, [modelName, datasheet]);

  return (
    <td
      ref={mountNode}
      className="samacsys-launcher"
      data-part-number={modelName}
      data-aatag={modelName}
      data-datasheet={datasheet}
      data-show-label="0"
    />
  );
};

export default Samacsys;
